import { AreasGet, AreasManagerGet } from "#core/Services/api_areas"
import { useApi } from "#hooks/useApi"
import { useMemo } from "react"
import { InputAutocompleteId } from "./InputAutocompleteId"

/**
 * Componente InputAutocompleteAreasId.
 *
 * @description
 * Componente basado en MUI Autocomplete que permite seleccionar un área.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.label - Texto que se mostrará como label del input.
 * @param {any} props.value - Valor actualmente seleccionado.
 * @param {function} props.setValue - Función para actualizar el valor seleccionado.
 * @param {Object} props.manager - trae los departamentos específicos del encargado .
 * @param {boolean} [props.autoFetch=true] - Indica si se deben cargar los datos automáticamente al montar el componente.
 *
 * @returns {JSX.Element} Componente Autocomplete para seleccionar un área.
 */
export function InputAutocompleteAreasId({
	label,
	value,
	setValue,
	manager,
	autoFetch = true,
}) {
	const departamentoGet = useMemo(() => {
		return manager ? AreasManagerGet : AreasGet
	}, [manager])

	const params = useMemo(() => ({ list: true }), [])
	const { data: dataDepartamento, loading } = useApi(departamentoGet, {
		autoFetch,
		params,
	})
	const areas = useMemo(() => {
		return dataDepartamento?.areas ?? []
	}, [dataDepartamento])

	return (
		<InputAutocompleteId
			data={areas}
			label={label ?? "Departamento"}
			value={value}
			setValue={setValue}
			loading={loading}
		/>
	)
}
